import { render } from "./ScreenItem.vue?vue&type=template&id=cfc3f436&scoped=true"
import script from "./ScreenItem.vue?vue&type=script&lang=js"
export * from "./ScreenItem.vue?vue&type=script&lang=js"

import "./ScreenItem.vue?vue&type=style&index=0&id=cfc3f436&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfc3f436"]])

export default __exports__